<template>
  <svg :width="width" :height="height" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.6905 48.2405C60.09 48.6215 60.1047 49.254 59.7234 49.6532L43.6933 66.4335L37.2458 59.0336C36.8832 58.6174 36.9268 57.9863 37.3434 57.6239C37.7599 57.2615 38.3916 57.3052 38.7542 57.7214L43.7613 63.468L58.2767 48.2733C58.658 47.8741 59.291 47.8594 59.6905 48.2405Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.719 10.7918C31.9875 10.8232 32.097 11.1767 31.898 11.3747L30.1578 13.1123L30.5954 15.5887C30.6451 15.8696 30.3568 16.0882 30.118 15.9426L27.9997 14.7459L25.8913 15.9426C25.6426 16.0882 25.3642 15.8696 25.4139 15.5887L25.8515 13.1123L24.1014 11.3747C23.9027 11.1771 24.0119 10.8232 24.2903 10.7918L26.6771 10.4589L27.7112 8.19051C27.8306 7.93024 28.1787 7.93024 28.2978 8.19051L29.3319 10.4589L31.719 10.7918Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.719 4.79653C44.9875 4.82786 45.097 5.18143 44.898 5.37939L43.1578 7.11697L43.5954 9.59338C43.6451 9.87431 43.3568 10.0929 43.118 9.9473L40.9997 8.7506L38.8913 9.9473C38.6426 10.0929 38.3642 9.87431 38.4139 9.59338L38.8515 7.11697L37.1014 5.37939C36.9027 5.18178 37.0119 4.82786 37.2903 4.79653L39.6771 4.46362L40.7112 2.1952C40.8306 1.93493 41.1787 1.93493 41.2978 2.1952L42.3319 4.46362L44.719 4.79653Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57.719 10.7918C57.9875 10.8232 58.097 11.1767 57.898 11.3747L56.1578 13.1123L56.5954 15.5887C56.6451 15.8696 56.3568 16.0882 56.118 15.9426L53.9997 14.7459L51.8913 15.9426C51.6426 16.0882 51.3642 15.8696 51.4139 15.5887L51.8515 13.1123L50.1014 11.3747C49.9027 11.1771 50.0119 10.8232 50.2903 10.7918L52.6771 10.4589L53.7112 8.19051C53.8306 7.93024 54.1787 7.93024 54.2978 8.19051L55.3319 10.4589L57.719 10.7918Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.1575 13.8977L72 27.5626V28.2126C72 48.8606 64.3867 61.791 56.7115 69.5571C52.8835 73.4305 49.0539 76.0059 46.1758 77.6152C44.7363 78.4201 43.533 78.9843 42.6842 79.3491C42.2597 79.5315 41.9237 79.6642 41.6908 79.7523C41.5743 79.7963 41.4837 79.8292 41.4206 79.8515C41.389 79.8627 41.3644 79.8713 41.3469 79.8773L41.326 79.8844L41.3196 79.8866L41.3175 79.8873C41.3175 79.8873 41.316 79.8878 41 78.9398C40.6464 79.8744 40.645 79.8739 40.645 79.8739L40.6367 79.8707L40.6161 79.8628C40.5989 79.8561 40.5744 79.8465 40.5431 79.834C40.4805 79.8091 40.3903 79.7724 40.2744 79.7235C40.0425 79.6258 39.7075 79.4791 39.2841 79.2795C38.4376 78.8803 37.2367 78.2687 35.7998 77.4114C32.9271 75.6975 29.1035 72.9973 25.2808 69.0433C17.6194 61.1189 10 48.1946 10 28.2126V27.5599L41.1575 13.8977ZM41 78.9398L40.6464 79.8744L40.9788 80L41.316 79.8878L41 78.9398ZM41.0204 77.869C41.2261 77.7906 41.5213 77.6735 41.8939 77.5133C42.6858 77.173 43.8262 76.6389 45.1992 75.8712C47.9461 74.3353 51.6165 71.8683 55.2885 68.1529C62.5341 60.8213 69.8403 48.5762 69.9974 28.8615L41.1533 16.082L12.0028 28.8641C12.1658 47.9037 19.463 60.1494 26.7192 67.6548C30.3965 71.4583 34.0729 74.0535 36.8252 75.6955C38.2008 76.5163 39.3437 77.0978 40.1377 77.4722C40.5151 77.6502 40.8135 77.7813 41.0204 77.869Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.7528 55.6163L27.7568 55.6118C27.7622 55.6058 27.7717 55.5954 27.7852 55.5807C27.8124 55.5513 27.856 55.5051 27.9157 55.4444C28.0353 55.3229 28.2191 55.1438 28.4652 54.9261C28.9579 54.4904 29.6968 53.903 30.6653 53.3141C32.6016 52.1368 35.4407 50.9617 39.0684 50.9617C41.816 50.9617 44.3236 51.4592 46.604 52.4418C47.1112 52.6603 47.6996 52.4266 47.9183 51.9199C48.137 51.4132 47.9031 50.8252 47.396 50.6067C44.8435 49.5069 42.0634 48.9632 39.0684 48.9632C34.9929 48.9632 31.7978 50.2861 29.6257 51.6069C28.54 52.267 27.7061 52.9287 27.1397 53.4297C26.8562 53.6804 26.6388 53.8916 26.4895 54.0434C26.4148 54.1193 26.3571 54.1803 26.3166 54.2242C26.2963 54.2461 26.2804 54.2637 26.2687 54.2766L26.2544 54.2926L26.2498 54.2979L26.248 54.2999L26.2473 54.3007C26.2473 54.3007 26.2467 54.3014 27 54.9585L26.2473 54.3007C25.8841 54.7164 25.9263 55.3483 26.3424 55.7113C26.7582 56.074 27.3895 56.0314 27.7528 55.6163Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.5 29.9781C34.3579 29.9781 31 33.3333 31 37.4722C31 41.6111 34.3579 44.9664 38.5 44.9664C42.6421 44.9664 46 41.6111 46 37.4722C46 33.3333 42.6421 29.9781 38.5 29.9781ZM29 37.4722C29 32.2296 33.2533 27.9797 38.5 27.9797C43.7467 27.9797 48 32.2296 48 37.4722C48 42.7148 43.7467 46.9648 38.5 46.9648C33.2533 46.9648 29 42.7148 29 37.4722Z"
      fill="#05070F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BackgroundChecksIllustration',
  props: {
    width: {
      type: Number,
      default: 82,
    },
    height: {
      type: Number,
      default: 82,
    },
  },
};
</script>
